<!--<ng-container *ngIf="!isLoggedToFirebase">-->
<!--  <button [disabled]="true" mat-icon-button>-->
<!--    <i class="mdi mdi-account-question-outline"></i>-->
<!--  </button>-->
<!--</ng-container>-->
<!--<ng-container *ngIf="isLoggedToFirebase">-->

<button
  *appIfUserHas="['GOD_MODE']"
  mat-icon-button
  (click)="displaySuperAdminNameAsk=true"
>
  <i class="mdi mdi-shield-star-outline"></i>
</button>


<button
  [disabled]="nbUsers <= 1"
  [matMenuTriggerFor]="menu"

  class="whois-online-button"
  mat-icon-button

  [matBadge]="nbUsers"
  [matBadgeOverlap]="true"
  [matBadgePosition]="'below'"
  [matBadgeHidden]="nbUsers <= 1"

>
  <mat-icon *ngIf="nbUsers <= 1">how_to_reg</mat-icon>
  <mat-icon *ngIf="nbUsers > 1">account_circle</mat-icon>

</button>
<mat-menu #menu="matMenu" [overlapTrigger]="false">
  <span class="info-menu-item">{{nbUsers}} {{'autres utilisateurs sur cet écran'|translate}}.</span>

  <span class="info-menu-item" *ngFor="let user of userList">
        <span appFlexLayout="row" appFlexAlign="start center">

            <i class="mdi mr-8"
               [class.mdi-account-clock-outline]="user?.status==='idle' && !user?.superUser?.name"
               [class.mdi-account-check-outline]="user?.status==='active' && !user?.superUser?.name"
               [class.mdi-account-clock]="user?.status==='idle' && user?.superUser?.name"
               [class.mdi-account-check]="user?.status==='active' && user?.superUser?.name"
            >
            </i>
            <span *ngIf="user?.superUser?.name" class="text-bold"> [{{user?.superUser?.name}}]&nbsp;</span>
            <span class="iso">
              {{user?.userName}}
            </span>
        </span>
      </span>

</mat-menu>

<!--</ng-container>-->


<dx-popup
  *ngIf="displaySuperAdminNameAsk"

  [width]="'50%'"
  [height]="'800px'"

  [showTitle]="true"
  [title]="'GOD_MODE USER detected!'"

  [dragEnabled]="true"

  [resizeEnabled]="true"

  [hideOnOutsideClick]="true"

  (onHiding)="hideSuperAdminAsk()"

  [visible]="displaySuperAdminNameAsk"

>
  <div *dxTemplate="let data of 'content'">

    <div appFlex="grow" appFlexLayout="column" style="overflow-y: hidden">
      <div appFlex="grow" appFlexLayout="row" style="overflow-y: hidden">

        <div appFlex="35%" appFlexAlign="center center">
          <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
               width="800" height="800"
               viewBox="0 0 48 48"
               style=" fill:#000000;">
            <path fill="#b71c1c" d="M19,16.84V13c0,0,4,0,9,3c3.092,1.855,6,4,10,4s7-2,7-2s0,8-5,14c-3.076,3.691-7.111,5-10,5	C19.125,37,19,16.84,19,16.84z"></path>
            <path fill="#ff3d00" d="M25.999,18.334L25,23v6H15v-6l-0.855-4.278c0,0-0.863-0.629-1.144-1.722s0-2.552,0-2.552	S14.5,13,18,13h2h6L25.999,18.334z"></path>
            <path fill="#ff9800" d="M18,14c0,0-0.042,2,2.041,2S22,14,22,14v-3h-4V14z"></path>
            <path fill="#ffb74d" d="M20,13c2.206,0,4-1.794,4-4V7l-2-2h-4l-2,2c0,0,0,1.012,0,2C16,11.206,17.793,13,20,13"></path>
            <path fill="#424242" d="M19,3l-1,1c-1.375,0.25-2,1.5-2,3v1l1,1V7l1-1l5,1v2l1-1V7c0-2.5-1.875-3.836-3.825-4H19z"></path>
            <path fill="#42a5f5" d="M25,29l1.709,13.673C26.864,43.909,25.9,45,24.655,45h-0.008c-0.964,0-1.8-0.665-2.017-1.605L20,32	l-2.63,11.395C17.154,44.335,16.317,45,15.353,45h-0.008c-1.245,0-2.208-1.091-2.054-2.327L15,29H25z"></path>
            <path fill="#1e88e5" d="M25,27v2l-5,3l-5-3v-2H25z"></path>
            <path fill="#ffca28" d="M17,19.5l3,3.5l3-3.5L21.5,18h-3L17,19.5z"></path>
            <path fill="#42a5f5" d="M27.107,10.19L25,13l0.999,5.334L30.6,12.2c0.192-0.257,0.32-0.556,0.373-0.871l0.732-4.392	c0,0-0.423-0.937-1.954-1.125s-1.988,0.449-1.988,0.449L27.107,10.19z"></path>
            <path fill="#ffb74d" d="M31.999,4.925c-0.034-0.93-0.717-1.738-1.67-1.897C30.192,3.004,30.055,2.996,29.922,3	c-0.934,0.033-1.736,0.719-1.895,1.671l-0.265,1.59l3.942,0.676l0.268-1.608C31.995,5.193,32.004,5.058,31.999,4.925z"></path>
            <path fill="#42a5f5" d="M12.102,20.455l2.043-1.733L13,14.448L7.811,18.85c-0.434,0.368-0.69,0.903-0.705,1.472	C7.09,20.89,7.318,21.439,7.732,21.83l3.454,3.263c0,0,1.158-0.03,2.002-0.968s0.729-1.955,0.729-1.955L12.102,20.455z"></path>
            <path fill="#ffb74d" d="M14,27c0.53,0,1.061-0.21,1.454-0.627c0.758-0.803,0.723-2.068-0.081-2.827l-1.456-1.376	l-2.731,2.922l1.441,1.362C13.013,26.819,13.507,27,14,27z"></path>
          </svg>
        </div>

        <div appFlex appFlexLayout="column">
          <div appFlex>
            <h1>Bienvenue GOD_MODE user !</h1>
          </div>
          <div appFlex="grow">
            <p>Tu n'es certainement peut être pas <b>{{authService.getDisplayName()}}</b>...</p>
            <p>Dis nous donc qui tu es:</p>
            <mat-form-field class="w-100-p p-8" style="margin-top:6px;">
              <mat-label>{{'Mon vrai nom...'|translate}}</mat-label>
              <input matInput [formControl]="fName.get('name')" autocomplete="off">
            </mat-form-field>

          </div>
        </div>

      </div>

      <div appFlex="65px" class="p-4" appFlexLayout="column" style="overflow-y: hidden">
        <div appFlex="grow" appFlexLayout appFlexAlign="end end">
          <button [disabled]="!fName.valid" mat-raised-button (click)="confirmSuperUser()">
            Confirm
          </button>
        </div>
      </div>

    </div>

  </div>

</dx-popup>
